import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export const DemoButton = ({ onSeeded }) => {
  const [loading, setLoading] = useState(false);

  const seed = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/demo/seed");
      toast.success(data.created > 0 ? `Loaded ${data.created} demo documents (fictional data)` : "Demo data already loaded");
      onSeeded();
    } catch (e) {
      toast.error("Could not load demo data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      data-testid="demo-data-toggle"
      onClick={seed}
      disabled={loading}
      className="flex items-center gap-2 bg-[#D6E0D9] text-[#2E5C50] hover:bg-[#C2D1C7] transition-colors duration-200 rounded-md px-4 py-2.5 text-sm font-medium disabled:opacity-60"
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" strokeWidth={1.5} /> : <Sparkles className="w-4 h-4" strokeWidth={1.5} />}
      Load Demo Data
    </button>
  );
};
